import React from "react";
import {
  Container,
  Grid,
  Skeleton,
  Box,
  Paper,
} from "@mui/material";

/**
 * Shimmer loading component for CreateInkMasterPage/EditInkMasterPage
 * Matches the structure of the Ink Master form with glass-card styling
 */
const CreateInkMasterPageShimmer = () => {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 6, md: 8 } }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: 3,
          backgroundColor: "transparent",
          backdropFilter: "blur(12px)",
          border: (theme) =>
            `1px solid ${
              theme.palette.mode === "dark"
                ? "rgba(255,255,255,0.08)"
                : "rgba(0,0,0,0.08)"
            }`,
          boxShadow: (theme) =>
            theme.palette.mode === "dark"
              ? "0 2px 8px rgba(0,0,0,0.1)"
              : "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        {/* Title Shimmer */}
        <Box sx={{ mb: 4 }}>
          <Skeleton
            variant="text"
            width={250}
            height={40}
            sx={{ borderRadius: 1 }}
          />
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {/* Quest Details Section */}
          <Box>
            <Skeleton
              variant="text"
              width={140}
              height={28}
              sx={{ mb: 2, borderRadius: 1 }}
            />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Skeleton
                variant="rounded"
                width="100%"
                height={40}
                sx={{ borderRadius: 999 }}
              />
              <Skeleton
                variant="rounded"
                width="100%"
                height={100}
                sx={{ borderRadius: 999 }}
              />
              <Skeleton
                variant="rounded"
                width="100%"
                height={40}
                sx={{ borderRadius: 999 }}
              />
              <Skeleton
                variant="rounded"
                width="100%"
                height={40}
                sx={{ borderRadius: 999 }}
              />
              <Skeleton
                variant="rounded"
                width="100%"
                height={40}
                sx={{ borderRadius: 999 }}
              />
            </Box>
          </Box>

          {/* Quest Period Section */}
          <Box>
            <Skeleton
              variant="text"
              width={140}
              height={28}
              sx={{ mb: 2, borderRadius: 1 }}
            />
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Skeleton
                  variant="rounded"
                  width="100%"
                  height={40}
                  sx={{ borderRadius: 999 }}
                />
              </Grid>
              <Grid item xs={6}>
                <Skeleton
                  variant="rounded"
                  width="100%"
                  height={40}
                  sx={{ borderRadius: 999 }}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Rewards Section */}
          <Box>
            <Skeleton
              variant="text"
              width={100}
              height={28}
              sx={{ mb: 2, borderRadius: 1 }}
            />
            <Grid container spacing={2}>
              {[1, 2, 3].map((i) => (
                <Grid item xs={4} key={i}>
                  <Skeleton
                    variant="rounded"
                    width="100%"
                    height={40}
                    sx={{ borderRadius: 999 }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Criteria Section */}
          <Box>
            <Skeleton
              variant="text"
              width={160}
              height={28}
              sx={{ mb: 2, borderRadius: 1 }}
            />
            <Skeleton
              variant="rounded"
              width="100%"
              height={120}
              sx={{ borderRadius: 999 }}
            />
          </Box>

          {/* Participation Section */}
          <Box>
            <Skeleton
              variant="text"
              width={240}
              height={28}
              sx={{ mb: 2, borderRadius: 1 }}
            />
            <Skeleton
              variant="rounded"
              width="100%"
              height={80}
              sx={{ borderRadius: 999 }}
            />
          </Box>

          {/* Submit Button Shimmer */}
          <Skeleton
            variant="rounded"
            width={200}
            height={48}
            sx={{ mt: 2, borderRadius: 20 }}
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default CreateInkMasterPageShimmer;

